import { createModel } from '@rematch/core';
import { UserPatient } from '../../models/user-patient';

export interface State {
    identityName: string;
    impsId: number;
    name: string;
    primary: boolean;
    coordinates: Undefinable<PatientCoordinates>;
    locked: boolean;
}

export const accounts = createModel<State>({
    state: {
        identityName: '',
        impsId: 0,
        name: '',
        primary: false,
        coordinates: {},
        locked: false
    },
    reducers: {
        lockAccount: (
            state: State,
            locked: boolean
        ): State => ({
            ...state,
            locked: locked
        }),
        update: (
            state: State,
            data: UserPatient
        ): State => ({
            ...state,
            ...data
        })
    }
});
